import langFilter from "../filters/lang.filter";
export default{
    bind(el, {value}, test){
        M.Tooltip.init(el, {html: langFilter(value) === '[translation error]' ? value : langFilter(value), position: 'top'})
    },
    unbind(el){
        const tooltip = M.Tooltip.getInstance(el);
        if (tooltip && tooltip.destroy) tooltip.destroy()
    }
}
